import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "owner-idea text-grey" }
const _hoisted_2 = { class: "owner-identifier" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_relationship_board = _resolveComponent("ontos-relationship-board")!
  const _component_ontos_view_instance_dialog = _resolveComponent("ontos-view-instance-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.owner && _ctx.property)
      ? (_openBlock(), _createBlock(_component_ontos_relationship_board, {
          key: 0,
          "owner-context": _ctx.ownerContext,
          owner: _ctx.owner,
          property: _ctx.property,
          "reverse-info": _ctx.reverseInfo,
          domains: _ctx.relDomains,
          workspace: _ctx.workspace,
          "reload-owner": _ctx.reloadOwner,
          "onUpdate:owner": _cache[0] || (_cache[0] = ($event: any) => (_ctx.owner = $event)),
          onOpenInstance: _ctx.onOpenInstance,
          onNoDimensions: _ctx.goToOwner,
          onShowMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, {
          title: _withCtx(() => [
            _createVNode(_component_ontos_page_header, {
              title: _ctx.property.name
            }, {
              subtitle: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.ownerIdeaName), 1),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.ownerLabel), 1)
              ]),
              _: 1
            }, 8, ["title"])
          ]),
          controls: _withCtx(() => [
            _createVNode(_component_ontos_header_action, {
              icon: "mdi-arrow-left",
              label: _ctx.ownerIdeaName,
              to: _ctx.ownerRoute
            }, null, 8, ["label", "to"])
          ]),
          _: 1
        }, 8, ["owner-context", "owner", "property", "reverse-info", "domains", "workspace", "reload-owner", "onOpenInstance", "onNoDimensions"]))
      : _createCommentVNode("", true),
    (_ctx.instanceOnView)
      ? (_openBlock(), _createBlock(_component_ontos_view_instance_dialog, {
          key: 1,
          context: _ctx.instanceOnView,
          preview: _ctx.previewOnView,
          workspace: _ctx.workspace,
          onChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.load())),
          onDeleted: _cache[4] || (_cache[4] = ($event: any) => (_ctx.load())),
          onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.instanceOnView = null)),
          onShowMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showMessage', $event))),
          onShowErrorMessage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
        }, null, 8, ["context", "preview", "workspace"]))
      : _createCommentVNode("", true)
  ]))
}